import React, { useState, useEffect } from "react";
import { Form, Col, Row } from "react-bootstrap";
import axios from "axios";
import PhoneInput from "react-phone-number-input";
import Payment from "../../../../Helpers/Payment";
import "./DonateForm.css";

const DonateForm = () => {
  const [formData, setFormData] = useState();
  const [change, setChange] = useState(false);
  const [donationError, setDonationError] = useState({});

  const formHandler = (e) => {
    if (e.target.name === "other") {
      const div = document.getElementsByClassName("amt");
      for (var i = 0; i < div.length; i++) {
        div[i].checked = false;
      }
    } else if (e.target.name === "amount") {
      document.getElementsByName("other")[0].value = "";
      //setFormData({...formData,"other": ""})
    } else {
      setFormData({ ...formData, [e.target.name]: e.target.value });
    }
  };

  useEffect(() => {
    if (localStorage.getItem("userMail")) {
      const body = {
        email: localStorage.getItem("userMail"),
      };
      axios
        .post("http://localhost:5000/donate/find", body)
        .then((res) => {
          if (res.status === 200) {
            setFormData({
              purpose: res.data.purpose,
              name: res.data.name,
              email: res.data.email,
              phone: res.data.phone,
              pan: res.data.pan,
              pin: res.data.pincode,
              street: res.data.streetName,
            });
          }
        })
        .catch((err) => console.log(err));
    }
  }, []);

  const phoneHandler = (e) => {
    // e.preventDefault();
    setFormData({ ...formData, phone: e });
  };

  const submitDonateForm = (event) => {
    event.preventDefault();
    var form = document.getElementById("donateForm");
    form.classList.add("was-validated");
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    } else {
      const div = document.getElementsByClassName("amt");
      var amount = "";
      for (var i = 0; i < div.length; i++) {
        if (div[i].checked === true) {
          amount = div[i].value;
        }
      }
      if (
        amount === "" &&
        document.getElementsByName("other")[0].value !== ""
      ) {
        amount = document.getElementsByName("other")[0].value;
      }
      if (amount === "") {
        setDonationError({
          message: "Please enter some amount",
        });
      } else {
        const body = {
          amount: amount,
          purpose: formData.purpose,
          name: formData.name,
          phone: formData.phone,
          email: formData.email,
          pan: formData.pan || "",
          pin: formData.pin,
          street: formData.street || "",
        };
        axios
          .post("https://animal-ngo.herokuapp.com/payment/donate", body)
          .then((res) => {
            const data = res.data;
            new Payment(
              data.id,
              data.amount,
              data.currency,
              "donation",
              body.name,
              body.email,
              body.phone,
              {
                name: body.name,
                pan: body.pan,
                pin: body.pin,
                street: body.street,
                purpose: body.purpose,
                paid_for: "donation",
              }
            ).pay();
          })
          .catch((err) => console.log(err));
      }
    }
  };

  return (
    <>
      <div className="form-wrapper">
        <div className="form-container scrollbar-hide form-container-donate">
          <Form
            onSubmit={(e) => submitDonateForm(e)}
            className="needs-validation w-100"
            id="donateForm"
            noValidate
          >
            <Row className="donation scrollbar-hide">
              <div className="col-auto flex-row px-0 donate-amount">
                <div className="form-check  d-inline">
                  <input
                    className="form-check-input amt"
                    type="radio"
                    name="amount"
                    id="500"
                    value="500"
                    onChange={formHandler}
                  />
                  <label className="form-check-label" htmlFor="500">
                    <span className="rupeeIcon"> ₹</span>500
                  </label>
                </div>

                <div className="form-check  d-inline">
                  <input
                    className="form-check-input amt"
                    type="radio"
                    name="amount"
                    id="2000"
                    value="2000"
                    onChange={formHandler}
                  />
                  <label className="form-check-label" htmlFor="2000">
                    <span className="rupeeIcon"> ₹</span>2,000
                  </label>
                </div>

                <div className="form-check  d-inline">
                  <input
                    className="form-check-input amt"
                    type="radio"
                    name="amount"
                    id="5000"
                    value="5000"
                    onChange={formHandler}
                  />
                  <label className="form-check-label" htmlFor="5000">
                    <span className="rupeeIcon"> ₹</span>5,000
                  </label>
                </div>

                <div className="form-check  d-inline">
                  <input
                    className="form-check-input amt"
                    type="radio"
                    name="amount"
                    id="10000"
                    value="10000"
                    onChange={formHandler}
                  />
                  <label className="form-check-label" htmlFor="10,000">
                    <span className="rupeeIcon"> ₹</span>10,000
                  </label>
                </div>

                <div className="form-check  d-inline">
                  <span className="rupeeIcon">₹</span>
                  <input
                    type="number"
                    name="other"
                    className="form-control d-inline OtherInput"
                    placeholder="Other"
                    onChange={formHandler}
                  />
                </div>
              </div>
            </Row>
            <Row>
              <Form.Group as={Col}>
                <input
                  type="text"
                  className="form-control col-md-4 ml-4 md-4 mt-2"
                  value={formData?.purpose && formData?.purpose}
                  name="purpose"
                  placeholder="Purpose*"
                  id="donate-purpose"
                  required
                  onChange={formHandler}
                />
              </Form.Group>
            </Row>
            <Row>
              <Form.Group as={Col}>
                <input
                  type="text"
                  value={formData?.name && formData?.name}
                  name="name"
                  className="form-control mt-2"
                  placeholder="Name*"
                  required
                  onChange={formHandler}
                />
                <PhoneInput
                  placeholder="00000 000000"
                  id="phone-input"
                  className="mt-2"
                  name="phone"
                  onChange={(e) => phoneHandler(e)}
                  international
                  defaultCountry="IN"
                  countryCallingCodeEditable={false}
                  required
                />
                <input
                  type="text"
                  name="email"
                  value={formData?.email && formData?.email}
                  className="form-control mt-2 col-md-4 mr-md-2"
                  placeholder="Email*"
                  required
                  onChange={formHandler}
                />
              </Form.Group>
            </Row>
            <Row>
              <Form.Group as={Col}>
                <input
                  type="text"
                  name="pan"
                  value={formData?.pan && formData?.pan}
                  className="form-control mt-2"
                  placeholder="Pan (if 80G needed)"
                  onChange={formHandler}
                />
                <input
                  type="text"
                  name="pin"
                  value={formData?.pin && formData?.pin}
                  className="form-control mt-2"
                  placeholder="Pincode*"
                  required
                  onChange={formHandler}
                />
                <input
                  type="text"
                  name="street"
                  value={formData?.street && formData?.street}
                  className="form-control mt-2"
                  placeholder="Street Name"
                  onChange={formHandler}
                />
              </Form.Group>
            </Row>
            <div className="row mt-4 mb-2 d-flex justify-content-center">
              <button className="btn submitFormBtn" type="submit">
                Donate
              </button>
            </div>
          </Form>
        </div>
      </div>
    </>
  );
};

export default DonateForm;
